<script setup lang="ts">
import { getPickupPoints } from '@caks/shared/api/user.route'
import { ILMap } from '@caks/shared/modules/i'
import { useAccountStore } from '@caks/shared/store/store.account'
import { PickupPoint } from '@caks/shared/types/types.api'
import { ChipTag } from '@caks/uikit/chip'

const accountStore = useAccountStore()
const coordinates = ref<PickupPoint[]>([])
const store = useAccountStore()

const shapeCards = [
  {
    title: 'НАДЕЖНЫЙ',
    subtitle: 'Приумножаем доверие гостей, коллег и партнеров, на протяжении всего пути ',
    description: 'отзывчивые, удобные, уверенные, сплоченные, ответственные',
  },
  {
    title: 'ОСОЗНАННЫЙ',
    subtitle: 'Мы понимаем смысл своих действий и оцениваем последствия',
    description:
      'нет границ, свободные, настоящие, искренние, развивающиеся, уверенные, уважающие, амбициозные, основательные, тактичные',
  },
  {
    title: 'ПОЗИТИВНЫЙ',
    subtitle: 'Извлекаем положительный опыт из любой ситуации',
    description: 'позитивные, творческие, душевные',
  },
  {
    title: 'ВНИМАТЕЛЬНЫЙ',
    subtitle: 'С заботой и вниманием к каждому',
    description: 'клиентоориентированные, душевные, уважающие',
  },
]

const shapeDescriptions = [
  {
    title: 'Создавая блюда для людей',
    description:
      '«Вкусная еда – это вдохновение и честность». Мы честны создавая свой продукт и относимся к нему с уважением. Предлагая гостям изо дня в день качественный продукт, который сохраняет свой вкус, не зависимости от обстоятельств, мы формируем сильный бренд и лояльных гостей.',
  },
  {
    title: 'Собственное производство',
    description:
      'Индивидуально разработанная линия производства сендвичей, которая позволяет стандартизировать продукт, оптимизировать себестоимость и увеличить объемы выпускаемой продукции. Централизованная закупка товара и взаимодействие с производителями, продукт максимально стандартизирован и оптимален по стоимости закупки',
  },
]

watch(
  () => accountStore.cityId,
  async (newValue) => {
    if (newValue !== null) {
      coordinates.value = []
      const { data } = await getPickupPoints(newValue)

      coordinates.value = data.pickup_points
    }
  }
)

const isMount = ref(false)

onMounted(async () => {
  isMount.value = true

  const cityId = localStorage.getItem('caksCityId') as string
  const { data } = await getPickupPoints(+cityId)

  coordinates.value = data.pickup_points
})
</script>

<template>
  <main class="about">
    <img
      src="https://s3.timeweb.com/de297931-466bb756-c7e6-41c7-9edf-55ccb15760e2/2c3447f47d4b469090e2d69cda1d0c39.jpeg"
      alt="about-image-1"
      class="about__image"
    />
    <div class="about__text-main">
      <h2 class="about__title-text">О компании</h2>
      <p>
        САК`С — это сеть ресторанов быстрого питания родом с Кавказа. В нашей сети уже 13 заведений
        и мы продолжаем расти. Залог устойчивого развития — неукоснительное соблюдение принципов.
      </p>
    </div>
    <div class="about__text-main about__text-main_green">
      <h2 class="about__title-text">Наша миссия</h2>
      <p>
        Мы ежедневно создаем уникальный продукт и атмосферу с заботой и вниманием к каждому гостю
      </p>
    </div>
    <img
      src="https://s3.timeweb.com/de297931-466bb756-c7e6-41c7-9edf-55ccb15760e2/bd0cbdb2200c4be3adf5c81a2ffecb74.jpeg"
      alt="about-image-2"
      class="about__image"
    />
    <section class="about__shape shape">
      <h2 class="about__title-text">Образ САК’С</h2>
      <div class="shape__separator"></div>
      <div class="shape__text-cards-block">
        <article v-for="card in shapeCards" class="shape__text-card">
          <p v-for="text in card">{{ text }}</p>
        </article>
      </div>
    </section>
    <img
      src="https://s3.timeweb.com/de297931-466bb756-c7e6-41c7-9edf-55ccb15760e2/4b3ac4236c2743a4a1ce6e9152ed5e29.jpeg"
      alt="about-image-3"
      class="about__image about__image_large-margin"
    />
    <div v-for="block in shapeDescriptions" class="about__text-main">
      <h2 class="about__title-text">{{ block.title }}</h2>
      <p>{{ block.description }}</p>
    </div>
    <img
      src="https://s3.timeweb.com/de297931-466bb756-c7e6-41c7-9edf-55ccb15760e2/f4cad2a56ead47f68d3f4158cc2628c8.jpeg"
      alt="about-image-4"
      class="about__image"
    />
    <div class="about__addresses">
      <h2 class="about__title-text">Адреса ресторанов</h2>
      <div class="about__map">
        <i-l-map
          v-if="coordinates.length"
          :lon="coordinates[0].lon"
          :lat="coordinates[0].lat"
          :points="coordinates"
          desktop
        />
        <skeletor v-else style="border-radius: 0" />
      </div>
    </div>
  </main>

  <teleport v-if="isMount" to=".sub-header__chips">
    <li
      v-if="store.categories.length"
      v-for="(food, index) of store.categories"
      :id="`chip-index-${index}`"
      ref="categoriesChipsElements"
      class="category-chip"
    >
      <chip-tag bigger @click="$router.push('/')">
        {{ food.name }}
      </chip-tag>
    </li>
    <div v-else class="chips-skeletons">
      <skeleton-chip v-for="_ in 6" />
    </div>
  </teleport>
</template>

<style scoped lang="scss">
.about {
  max-width: 1336px;
  margin: 0 auto;

  &__title-text {
    @include h1-1;
    color: $primary-text;
  }

  &__image {
    margin-top: 40px;
    height: 432px;
    object-fit: cover;
    background-position: center;

    &_large-margin {
      margin-top: 80px;
    }
  }

  &__text-main {
    display: flex;
    gap: 32px;
    margin-top: 40px;

    h2 {
      width: 304px;
    }

    p {
      @include h4-7;
      width: 416px;
      color: $primary-text;
    }

    &_green {
      p {
        color: $primary-green;
        @include h3-4;
      }
    }
  }

  .shape {
    margin-top: 80px;

    &__separator {
      height: 4px;
      background-color: $ui-gray-2;
      margin-top: 32px;

      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 100%;
        background-color: $primary-green;
      }
    }

    &__text-cards-block {
      display: flex;
      gap: 24px;
      margin-top: 32px;
    }

    &__text-card {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 320px;

      p {
        @include h4-7;
        color: $primary-text;

        &:first-child {
          text-transform: uppercase;
          color: $primary-green;
        }

        &:last-child {
          color: $primary-green;
        }
      }
    }
  }

  &__addresses {
    margin-top: 60px;

    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  &__map {
    height: 432px;
    margin-bottom: 80px;
  }
}
</style>
